import { CODES_DISABLED_IN_SALE } from './config';

export default function (code) {
    return CODES_DISABLED_IN_SALE.indexOf(code) === -1;
}
